import { Spin, SpinProps } from 'antd';
import * as React from 'react';

export const AbsoluteSpinner: React.FC<Partial<SpinProps>> = (props) => (
  <Spin
    size='large'
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    }}
    {...props}
  />
);
